import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.BarChartView extends Monitoring.Reports.Executive.AbstractSectionView

  render: ->
    @bindChartsReady(1)
    @$el.html(@genericTemplate(self: this))
    @addBars('.chart_container')
    return this

  addBars: (divId) ->
    @specific_settings ||= {}
    @specific_settings.benchmark = true
    fb_page = @getTemplateOptions().page
    query = _.extend({ anual_benchmark: true }, @accountSentimentQuery(), @getExtraQuery(), {page: fb_page})
    @setBenchmarkSettingsIfNecessary(query)
    f = @_addChart(@target[@getTemplateOptions().dimension], @_columnOptions)
    f(query, divId)
